module.exports = __webpack_public_path__ + "img/金烽现场技术支援系统(1).dccce775.png";